import { Controller } from "@hotwired/stimulus"

import DisclosureItemController from "./disclosure_item_controller"

import { debounce } from "@/helpers/utils"
import { isDesktop } from "@/helpers/window_size"

export default class extends Controller {
  static outlets = ["disclosure-item"]
  declare readonly disclosureItemOutlets: DisclosureItemController[]

  initialize(): void {
    this.toggleNavLinks = debounce(this.toggleNavLinks.bind(this), 100)
  }

  connect(): void {
    this.toggleNavLinks()
  }

  toggleNavLinks(): void {
    const isDesk = isDesktop()

    this.disclosureItemOutlets.forEach((disclosureItem) => {
      disclosureItem.openValue = isDesk
    })
  }
}
